module.exports = __webpack_public_path__ + "static/media/hockey.2b96bc2d.svg";